import React from "react"
import { COMMAND_PRIORITY_HIGH, DecoratorNode } from "lexical"

import { TableOfContentComponent } from "./TableOfContentComponent"

export class TableOfContentNode extends DecoratorNode {
  __tableOfContentsData
  static getType() {
    return "table-of-content"
  }

  static clone(node) {
    return new TableOfContentNode(node.__tableOfContentsData, node.__key)
  }

  static importJSON(serializedNode) {
    return $createTableOfContentNode(serializedNode.tableOfContentsData)
  }

  static importDOM() {
    return {
      span: (domNode) => {
        const tp = domNode.getAttribute("type")
        if (tp !== this.getType()) return null

        return {
          conversion: convertTableOfContentElement,
          priority: COMMAND_PRIORITY_HIGH,
        }
      },
    }
  }

  constructor(tableOfContentsData, key) {
    super(key)
    this.__tableOfContentsData = tableOfContentsData
  }

  exportJSON() {
    const tableOfContentsData = this.__tableOfContentsData
    return {
      type: this.getType(),
      ...(tableOfContentsData ? { tableOfContentsData } : {}),
      version: 1,
    }
  }

  createDOM() {
    const el = document.createElement("span")
    el.style.display = "inline-block"
    el.setAttribute("type", this.getType())
    return el
  }

  getTextContent() {
    return "\n"
  }

  updateDOM() {
    return false
  }

  decorate() {
    return (
      <TableOfContentComponent
        nodeKey={this.__key}
        tableOfContentsData={this.__tableOfContentsData}
      />
    )
  }
}

function convertTableOfContentElement() {
  return { node: $createTableOfContentNode() }
}

export function $createTableOfContentNode(currentTableOfContents) {
  return new TableOfContentNode(currentTableOfContents)
}

export function $isTableOfContentNode(node) {
  return node instanceof TableOfContentNode
}
